// extracted by mini-css-extract-plugin
export default {"container":"rW-z","title":"sW-z","link":"tW-z"};